
import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: '¿Qué tipo de vehículos compráis en vuestro desguace de Castelldefels?',
      answer: 'Compramos todo tipo de vehículos en Castelldefels: coches, furgonetas, motos, camiones. No importa el estado: accidentados, averiados, viejos, sin ITV, sin motor, sin ruedas. Compramos cualquier marca y modelo. Te damos el mejor precio del mercado.'
    },
    {
      question: '¿Cuánto pagáis por un coche para desguace en Castelldefels?',
      answer: 'El precio depende de la marca, modelo, año y estado del vehículo. Hacemos una valoración gratuita y te damos un precio justo en menos de 1 hora. Pagamos al instante en efectivo o transferencia. Solicita tu valoración sin compromiso.'
    },
    {
      question: '¿Cómo es el proceso para vender mi coche al desguace?',
      answer: 'Es muy sencillo: 1) Rellenas el formulario o nos llamas. 2) Te damos una valoración en menos de 1 hora. 3) Si aceptas, recogemos tu coche gratis. 4) Te pagamos al instante. 5) Tramitamos la baja en DGT y te entregamos el certificado. Sin complicaciones.'
    },
    {
      question: '¿La recogida del vehículo es gratuita en Castelldefels?',
      answer: 'Sí, la recogida es completamente gratuita en Castelldefels y alrededores. Incluimos el servicio de grúa sin coste adicional. No importa si el coche no arranca o está accidentado. Nos encargamos de todo el transporte.'
    },
    {
      question: '¿Quién se encarga de dar de baja el coche en la DGT?',
      answer: 'Nosotros nos encargamos de toda la gestión de baja definitiva en la DGT. Tramitamos todos los papeles y te entregamos el certificado de destrucción oficial. Tú no tienes que hacer ninguna gestión. Todo incluido en el servicio.'
    },
    {
      question: '¿Cuánto tiempo tarda todo el proceso de venta?',
      answer: 'El proceso es muy rápido. Te damos la valoración en menos de 1 hora. Si aceptas, podemos recoger el coche el mismo día o cuando tú prefieras. El pago es inmediato en el momento de la recogida. La baja en DGT la tramitamos en 48-72 horas.'
    },
    {
      question: '¿Qué documentos necesito para vender mi coche al desguace?',
      answer: 'Necesitas: DNI del propietario, permiso de circulación del vehículo y ficha técnica. Si no tienes algún documento, consúltanos. En algunos casos podemos ayudarte con la gestión de documentación faltante.'
    },
    {
      question: '¿Compráis coches sin ITV o con multas pendientes?',
      answer: 'Sí, compramos coches sin ITV, con multas pendientes o con cualquier problema administrativo. Te asesoramos sobre cómo resolver estas situaciones. En muchos casos podemos ayudarte con las gestiones necesarias en Castelldefels.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-12 sm:py-20 lg:py-28 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-16">
          <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-2 bg-teal-100 text-teal-700 rounded-full mb-3 sm:mb-4">
            <i className="ri-question-line text-base sm:text-lg"></i>
            <span className="text-xs sm:text-sm font-semibold whitespace-nowrap">PREGUNTAS FRECUENTES</span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4 px-2">
            ¿Dudas Sobre Vender tu Coche?
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-600 px-2">
            Resolvemos las preguntas más frecuentes sobre la venta de vehículos a nuestro desguace
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-3 sm:space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-lg sm:rounded-xl shadow-sm overflow-hidden transition-all duration-300 hover:shadow-md"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between p-4 sm:p-6 text-left cursor-pointer group"
              >
                <h4 className="text-sm sm:text-base lg:text-lg font-semibold text-gray-900 pr-3 sm:pr-4 group-hover:text-teal-600 transition-colors">
                  {faq.question}
                </h4>
                <div className={`w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center flex-shrink-0 bg-teal-100 rounded-full transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-lg sm:text-xl text-teal-600"></i>
                </div>
              </button>
              
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-4 sm:px-6 pb-4 sm:pb-6">
                  <p className="text-gray-600 leading-relaxed text-sm sm:text-base">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Contact CTA */}
        <div className="mt-8 sm:mt-12 text-center">
          <p className="text-gray-600 mb-3 sm:mb-4 text-sm sm:text-base">¿No encuentras la respuesta que buscas?</p>
          <a
            href="#valoracion"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('valoracion')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-2 px-5 sm:px-6 py-2.5 sm:py-3 bg-teal-600 text-white rounded-full font-medium hover:bg-teal-700 transition-colors whitespace-nowrap text-sm sm:text-base"
          >
            <i className="ri-customer-service-line text-lg sm:text-xl"></i>
            Solicitar Valoración Gratis
          </a>
        </div>
      </div>

      {/* Structured Data for FAQ */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": faqs.map(faq => ({
            "@type": "Question",
            "name": faq.question,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": faq.answer
            }
          }))
        })}
      </script>
    </section>
  );
}
